import React from "react";
import { motion } from "framer-motion";
import { FaUniversity } from "react-icons/fa";

const DirectorDesk = () => {
  return (
    <section className="relative py-24 px-6 md:px-16 overflow-hidden bg-[#040b1f]/50">
      {/* Subtle cosmic background */}
      <div className="absolute top-1/2 left-0 w-[600px] h-[600px] bg-purple-900/10 blur-[120px] rounded-full pointer-events-none -translate-y-1/2" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          {/* ── Message Section ── */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="lg:col-span-7 order-2 lg:order-1"
          >
            <div className="relative">
              <span
                className="section-badge mb-6"
                style={{
                  background: "rgba(139,92,246,0.1)",
                  border: "1px solid rgba(139,92,246,0.25)",
                  color: "#8b5cf6",
                }}
              >
                Visionary Leadership
              </span>
              <h2
                className="text-4xl md:text-5xl font-black text-white mb-8 leading-tight"
                style={{ fontFamily: "Orbitron, sans-serif" }}
              >
                President's <span style={{ color: "#8b5cf6" }}>Message</span>
              </h2>

              <div className="space-y-6 text-gray-400 text-lg leading-relaxed">
                <p className="relative pl-8 border-l-2 border-purple-500/30">
                  <span className="absolute left-0 top-0 text-purple-500 text-4xl opacity-50 font-serif">
                    "
                  </span>
                  It is with great pride that I welcome you to Galaxy Star
                  Public School, Sekhwan. Our school was founded to create a
                  nurturing space where academic excellence and overall
                  development are prioritized.
                </p>
                <p>
                  Our modern infrastructure reflects our focus on 21st-century
                  education. From well-equipped classrooms to vibrant areas for
                  extracurricular activities, our campus supports the holistic
                  growth of every student.
                </p>
                <p>
                  At Galaxy Star Public School, we strive to shape not just
                  successful learners but responsible citizens. I extend my
                  sincere thanks to our students, teachers, parents, and staff
                  for their continued support.
                </p>
              </div>

              {/* Official Seal / Signature */}
              <div className="mt-12 flex items-center gap-6 p-6 rounded-2xl bg-white/5 border border-white/10">
                <div className="w-16 h-16 rounded-full bg-purple-500/10 border border-purple-500/30 flex items-center justify-center text-purple-400">
                  <FaUniversity size={32} />
                </div>
                <div>
                  <p
                    className="text-white font-bold text-xl uppercase tracking-widest"
                    style={{ fontFamily: "Orbitron, sans-serif" }}
                  >
                    GK Prabhakar
                  </p>
                  <p className="text-purple-400 font-medium uppercase tracking-widest text-xs">
                    President, Galaxy Star Public School
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* ── Photo Section ── */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="lg:col-span-5 relative order-1 lg:order-2"
          >
            <div className="relative group">
              {/* Decorative Frame */}
              <div className="absolute -inset-4 border border-purple-500/20 rounded-2xl group-hover:border-purple-500/40 transition-colors duration-500" />
              <div className="absolute -inset-1 bg-gradient-to-bl from-purple-500/20 to-transparent blur-sm rounded-2xl" />

              {/* Main Image */}
              <div className="relative rounded-xl overflow-hidden shadow-2xl border border-white/10">
                <img
                  src="/renamed_website_images/president-gk-prabhakar.jpg"
                  alt="President Mr. GK Prabhakar"
                  className="w-full h-auto object-cover object-top transform transition-transform duration-700 group-hover:scale-[1.02]"
                  style={{ maxHeight: "550px", objectPosition: "center 15%" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#020810]/80 via-transparent to-transparent" />

                {/* Image Caption Overlay */}
                <div className="absolute bottom-6 left-6 right-6 text-right">
                  <h4 className="text-purple-400 font-black uppercase tracking-widest text-sm mb-1">
                    Founding Vision
                  </h4>
                  <p className="text-white text-lg font-bold">
                    Mr. GK Prabhakar
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DirectorDesk;
